import React from 'react';
import { MessageCircle } from 'lucide-react';
import { CONTACT } from './Constants';
export function TeamSection() {
  const team = [{
    role: 'Director de Tratamiento',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&auto=format&fit=crop&q=80'
  }, {
    role: 'Psicólogo',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&auto=format&fit=crop&q=80'
  }, {
    role: 'Técnico en Prevención y Terapia',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&auto=format&fit=crop&q=80'
  }, {
    role: 'Monitor Ocupacional',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&auto=format&fit=crop&q=80'
  }];
  return <section id="profesionales" className="py-16 md:py-24 bg-white" data-id="element-251">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-253">
          <h2 className="text-3xl md:text-4xl font-bold text-azul mb-6" data-id="element-254">
            Equipo profesional y multidisciplinario
          </h2>
          <p className="text-lg text-gray-600" data-id="element-255">
            En Evolución Chile contamos con profesionales del área terapéutica y
            clínica, incluyendo psiquiatras, psicólogos, terapeutas y monitores
            ocupacionales con trayectoria en acompañamiento emocional.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-256">
          {team.map((member, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-257">
              <div className="w-32 h-32 rounded-full overflow-hidden mb-4 border-4 border-celeste-light shadow-sm" data-id="element-258">
                <img src={member.image} alt={member.role} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-300" data-id="element-259" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-260">
                {member.role}
              </h3>
              <p className="text-sm text-celeste font-medium" data-id="element-261">
                Evolución Chile
              </p>
            </div>)}
        </div>

        <div className="bg-celeste-light/30 rounded-2xl p-8 text-center max-w-3xl mx-auto border border-celeste-light" data-id="element-262">
          <p className="text-lg text-azul font-medium mb-6" data-id="element-263">
            Si necesitas orientación sobre el proceso, puedes contactarnos
            directamente por WhatsApp o llamada.
          </p>
          <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3 border border-transparent rounded-full shadow-sm text-base font-semibold text-white bg-whatsapp hover:bg-whatsapp-hover transition-colors" data-id="element-264">
            <MessageCircle className="w-5 h-5 mr-2" data-id="element-265" />
            Hablar con Evolución Chile
          </a>
        </div>
      </div>
    </section>;
}